import React, { ReactElement } from "react";
import { getCurrentLang, getId } from "../../../helper/utils";
import FaqAccordion from "../faq/FaqAccordion";
import { getPrivacyPolicyFaqItems } from "./getPrivacyPolicyFaqItems";
import { useRouter } from "next/router";

const PrivacyPolicyFaqAccordion = (): ReactElement => {
  const router = useRouter();
  const expandedFaqId = getId(router);

  return (
    <FaqAccordion currentFaqId={expandedFaqId} faqs={getPrivacyPolicyFaqItems(getCurrentLang())} />
  );
}

export default PrivacyPolicyFaqAccordion;
